<script setup lang="ts">
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import { provide } from 'vue'

interface Props {
  data: DynamicAuctionItemList
}

const props = defineProps<Props>()

provide('auction-strapi-data', props.data)

useHead({
  bodyAttrs: {
    class: 'pb-28 sm:pb-24',
  },
})
</script>

<template>
  <div class="w-full">
    <Suspense>
      <template #default>
        <LazyDynamicAuctionItemListCarsList v-if="data.type === 'carList'" />
        <LazyDynamicAuctionItemListSearchList
          v-else-if="data.type === 'carSearch'"
        />
      </template>

      <template #fallback>
        <div class="container relative mx-auto mt-4 flex w-full gap-4">
          <div class="hidden w-1/4 flex-col gap-4 md:flex">
            <div class="h-[100vw] w-full animate-pulse rounded bg-gray-300">
              <span class="sr-only">{{ $t('loading') }}</span>
            </div>
          </div>
          <div class="ml-auto flex w-full flex-col gap-4 md:w-3/4">
            <div
              v-for="i in 10"
              :key="i"
              class="h-[250px] w-full animate-pulse rounded bg-gray-300"
            >
              <span class="sr-only">{{ $t('loading') }}</span>
            </div>
          </div>
        </div>
      </template>
    </Suspense>
  </div>
</template>
